module.exports = __webpack_public_path__ + "media/assets/icons/mail-92ed34bd3051e52793c1f1ddacf1bfa3.svg";